import { useEffect, useState } from 'react';
import { fetchStoreSettings } from '../services/services';

// Custom hook to manage store settings
export function useStoreSettings() {
    const [settings, setSettings] = useState({ fixed: 0, variable: 0, deliveryRadius: 0, isDeliveryAvailable: false });

    useEffect(() => {
        let cancelled = false;
        async function load() {
            try {
                const data = await fetchStoreSettings();
                if (!cancelled) {
                    setSettings({
                        fixed: data.fixedDeliveryPrice,
                        variable: data.variableDeliveryPrice,
                        deliveryRadius: data.deliveryRadius,
                        isDeliveryAvailable: data.activeDelivery,
                    });
                }
            } catch (err) {
                console.error('Error loading store settings:', err);
            }
        }
        load();
        return () => { cancelled = true; };
    }, []);

    return settings;
}